import axiosInstance from "../config/axiosInstance";
import { API_ENDPOINTS } from "../config/api";

export const getProfile = () => axiosInstance.get(API_ENDPOINTS.getProfile);

export const updateProfile = (payload: { userName: string; userEmail: string; phone: string }) =>
  axiosInstance.put(API_ENDPOINTS.updateProfile, payload);

export const getUserList = () => axiosInstance.get(API_ENDPOINTS.getUserList);

export const getUserEntity = (id: number) =>
  axiosInstance.get(API_ENDPOINTS.getUserEntity(id));

export const createUser = (payload: any) =>
  axiosInstance.post(API_ENDPOINTS.createUser, payload);

export const updateUser = (payload: any) =>
  axiosInstance.put(API_ENDPOINTS.updateUser, payload);

export const deleteUser = (id: number) =>
  axiosInstance.delete(API_ENDPOINTS.deleteUser(id));

export const resendInvitation = (userId: number) =>
  axiosInstance.post(API_ENDPOINTS.resendInvitation(userId));
